import Multiselect from 'vue-multiselect';
import dateSwitch from '@/components/dateSwitch/index.vue';
import tabView from '@/components/tabView/index.vue';
import search from '@/components/search/index.vue';

import Api from '@/utils/api';

export default {
  components: {
    Multiselect,
    dateSwitch,
    search,
    tabView,
  },
  data () {
    return {
      filter: {
        Language: [],
        Category: [],
        Access: [],
        Date: [null, null],
        Search: '',
      },

      allOption: '',
      langList: [],
      errorCategoryList: [],
      accessList: [],
    };
  },
  created () {
    this.getFilter();
  },
  methods: {

    /**
         * Limit text for multiselect
         *
         * @param {NUmber} count
         */
    limitText (count) {
      return `and ${count} others`;
    },

    selectAllLanguges (e) {
      this.filter = {
        ...this.filter,
        Language: {},
      };
    },

    /**
         * Get all filters
         */
    getFilter () {
      Api.getLanguage()
        .then((response) => {
          if (response.status === 200) {
            this.langList = response.data;

            this.$emit('getFilters', 'langList', this.langList);
          }
        });

      Api.settings.errorConfiguration
        .get()
        .then((response) => {
          if (response.status === 200) {
            this.errorCategoryList = response.data.Data;
            this.$emit('getFilters', 'errorCategoryList', this.errorCategoryList);
          }
        });

      Api.user
        .getAccounts()
        .then((response) => {
          if (response.data.Status) {
            this.accessList = response.data.Data;
            this.$emit('getFilters', 'accessList', this.accessList);
          }
        });
      this.filter.Page = 1;
      this.$emit('sendFilter', this.filter);
    },

    /**
         * Method for switch data
         *
         * @param {Array} item
         */
    dateSwitchJob (item) {
      this.filter.Date = item.value;
      this.$emit('sendFilter', this.filter);
      // this.$router.push({ query: { created_on: this.filter.Date.join(',') }});
    },

    /**
         * Method for set field search oi params
         */
    holderSearch (searchString) {
      this.filter.Search = searchString;
    },

    /**
         * Method for set field search oi params
         */
    resetSearch (searchString) {
      this.filter.Search = '';
    },

    /**
         * Reset filters
         */
    resetFilter () {
      this.filter = {
        Language: {},
        Category: [],
        Access: [],
        Date: [null, null],
        Search: '',
      };
    },
  },
};
